import api from './api';
import types from './mutation-types';

export default {
	/**commit mutations*/
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	/**call API */
	async getCommCodes_({ commit, rootState }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType, rootState['commonStore'].user.plantCd);
			if (header.code === 0) {
				await commit(types.DEFAULT_ASSIGN, { key, value: body });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error.header || error;
		}
	},
	async getPartCkuMngList_({ commit, state }) {
		try {
			const { searchParams, pagingInfo } = state;
			const data = await api.getPartCkuMngList({ searchParams, pagingInfo });
			if (data.header.code === 0) {
				const { pagingInfo, resultList, partCkuScrId } = data.body;
				commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo });
				commit(types.DEFAULT_ASSIGN, { key: 'resultList', value: resultList });
				commit(types.DEFAULT_ASSIGN, { key: 'partCkuScrId', value: partCkuScrId });
			} else if (data.header.code === 3) {
			}
			return data.header;
		} catch (error) {
			return error.header || error;
		}
	},
	async deletePartCkuMngList_({ state }, delRows) {
		try {
			const { header } = await api.deletePartCkuMngList(delRows);
			return header;
		} catch (error) {
			//return error.header || error;
			throw new Error(error.header.message || error);
		}
	}
};
